export enum ConstructionType {
    New = '1',
    Existing = '2',
}

export const constructionTypeReadable = (constructionType: ConstructionType): string => {
    const constructionTypes: string[] = [];
    constructionTypes[1] = 'Nieuwbouw';
    constructionTypes[2] = 'Bestaande bouw';
    return constructionTypes[parseInt(constructionType)];
};
